import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)           // auto-detect navigator.language or /es/ path
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es } },
    fallbackLng: "en",
    // Without this, the "path" detector reads the first path segment as a
    // language code: /faq would set i18n.language = "faq" and <html lang="faq">.
    supportedLngs: ["en", "es"],
    // The URL is the only source of the language: /es/... is Spanish and any
    // other path falls through to fallbackLng ("en"). Reading localStorage or
    // navigator here showed Spanish copy on English URLs (under English
    // canonicals) to anyone who had once picked Spanish or had a Spanish browser.
    detection: {
      order: ["path"],
      caches: []
    },
    interpolation: { escapeValue: false }
  });

export default i18n;
